export default __webpack_public_path__ + "static/media/safu_logo_text.880bca60.png";